import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const DevOauthStore = GenericFieldFactory("DEV_OAUTH");